<ng-icon
  size="25"
  name="bootstrapArrowBarDown"
  role="button"
  (click)="downloadReceipt()"
></ng-icon>
